<div
  class="add-item-dialog-header"
  style="
    padding: 30px 24px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  "
>
  <h1 style="font-size: 24px; padding: 0 30px">
    Shipment
    <span style="color: #ff6c36; font-weight: 600"
      >{{shipmentData?.shipment_number}}</span
    >
  </h1>
  <button
    (click)="close()"
    style="
      position: absolute;
      top: -18px;
      right: -18px;
      background-color: #fff;
      border: 1px solid #f4f4f4;
      border-radius: 100%;
      min-width: 36px;
      min-height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
    "
  >
    <i class="fas fa-times" style="font-size: 24px; color: red"></i>
  </button>
</div>

<div mat-dialog-content>
  <div
    class="print-invoice-and-label-dialog-content-wrapper"
    [ngClass]="showInvoice ? 'oneItem': 'twoItem'"
  >
    <div
      class="print-invoice-area"
      style="width: 100%"
      *ngIf="!showInvoice"
    >
      <button
        mat-flat-button
        class="shippn-mat-btn shippn-mat-btn-alt"
        style="width: 100%"
        (click)="printInvoice()"
      >
        Print Invoice
      </button>
    </div>

    <div class="print-label-area" style="width: 100%">
      <button
        mat-flat-button
        color="primary"
        class="shippn-mat-btn"
        style="width: 100%"
        (click)="printLabel(shipmentData?.label_url)"
      >
        Print Label
      </button>
    </div>
  </div>
</div>
